import { useNavigate } from 'react-router-dom';
import { CheckCircle, X, Save } from 'lucide-react';
import DownloadMenu from '../DownloadMenu';

interface AnalysisResultProps {
  content: string | null;
  onClose: () => void;
  onReset: () => void;
}

export default function AnalysisResult({ content, onClose, onReset }: AnalysisResultProps) {
  const navigate = useNavigate();

  const handleDiscard = () => {
    onClose();
    onReset();
  };

  const handleSave = () => {
    onClose();
    navigate('/');
  };

  if (!content) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="p-2 bg-success-100 dark:bg-success-900/30 rounded-full">
          <CheckCircle className="h-6 w-6 text-success-600 dark:text-success-400" />
        </div>
        <h2 className="text-2xl font-bold text-gradient-gold">
          Parecer Gerado com Sucesso!
        </h2>
      </div>

      <div className="prose dark:prose-invert max-w-none bg-navy-50 dark:bg-navy-800/50 p-6 rounded-xl border border-navy-200 dark:border-navy-700">
        {content.split('\n').map((paragraph, index) => (
          <p key={index} className="mb-4 text-navy-800 dark:text-navy-200">
            {paragraph.split('**').map((part, i) =>
              i % 2 === 1 ? <strong key={i} className="text-navy-900 dark:text-navy-100">{part}</strong> : part
            )}
          </p>
        ))}
      </div>

      <div className="flex justify-end space-x-3 pt-4 border-t border-navy-200 dark:border-navy-700">
        <button
          onClick={handleDiscard}
          className="inline-flex items-center px-4 py-2 text-navy-600 dark:text-navy-300 hover:bg-navy-100 dark:hover:bg-navy-800 rounded-lg transition-colors duration-200"
        >
          <X className="h-4 w-4 mr-2" />
          Descartar
        </button>
        <DownloadMenu content={content || ""} fileName="parecer" />
        <button
          onClick={handleSave}
          className="inline-flex items-center px-4 py-2 btn-accent rounded-lg"
        >
          <Save className="h-4 w-4 mr-2" />
          Salvar
        </button>
      </div>
    </div>
  );
}
